exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animate-spin[data-v-50436fa7]{animation:spin-50436fa7 1s linear infinite}@keyframes spin-50436fa7{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
